export default __webpack_public_path__ + "static/media/doctors.e08f133d.png";